import React, { useEffect, useState } from "react";
import { useSidebar } from "../../SidebarContext";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import { useRef } from "react";
import { parseDocument } from "htmlparser2";
import { DomUtils } from "htmlparser2";
import DOMPurify from 'dompurify';


export const convertHtmlToText = (html) => {
    if (!html || typeof html !== 'string') return '';
    try {
        const doc = parseDocument(html);
        return DomUtils.getText(doc).replace(/\s+/g, ' ').trim();
    } catch (err) {
        console.error("Failed to parse HTML to text:", err);
        return html;
    }
};
const Setting = () => {
    const url = process.env.REACT_APP_LINK;
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const [userData, setUserData] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [editMode1, setEditMode1] = useState(false);
    const [editMode1cart, setEditMode1cart] = useState(false);
    const [formData, setFormData] = useState({});
    const [help, setHelp] = useState({})
    const [userDatahelp, setUserDatahelp] = useState(null);
    const [useTextLogo, setUseTextLogo] = useState(false);
    const { isSidebarOpen } = useSidebar();
    const [deliveryPayData, setDeliveryPayData] = useState({});
    const [editDelivery, setEditDelivery] = useState(false);
    const autocompleteRef = useRef(null);
    const [deliveryRanges, setDeliveryRanges] = useState([]);
    const [newRange, setNewRange] = useState([{ price: "", min_km: "", max_km: "" }]);
    const [editId, setEditId] = useState(null);
    const [submittedRanges, setSubmittedRanges] = useState([]);
    const [cartButtons, setCartButtons] = useState([]);
    const [editButtonData, setEditButtonData] = useState(null); // for modal editing



    const token = localStorage.getItem("accessToken")
    console.log(token)

    const fetchSingleuser = async () => {
        try {
            const response = await fetch(`${url}/auth/singleuser/${isLoggedIn.user_id}`);
            const res = await response.json();
            setUserData(res);
            console.log(res)
            setFormData(res);
        } catch (error) {
            console.log(error);
        }
    };



    const addDeliveryRange = () => {
        setNewRange([...newRange, { price: "", min_km: "", max_km: "" }]);
    };

    const updateDeliveryRange = (index, field, value) => {
        const updatedRanges = [...newRange];
        updatedRanges[index][field] = value;
        setNewRange(updatedRanges);
    };

    const saveEdit = async (id) => {
        const updated = deliveryRanges.find(r => r.id === id);
        const res = await fetch(`${url}/freedelivery/${id}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updated),
        });
        const result = await res.json();
        if (!res.ok) return alert("Update failed");

        setEditId(null);
    };




    useEffect(() => {
        fetchSingleuser();


    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        setFormData({ ...formData, profilePic: file, orignal_logoname: null });
    };

    const handleTextLogoChange = (e) => {
        setFormData({ ...formData, orignal_logoname: e.target.value, profilePic: null });
    };

    const handleSubmit = async () => {
        const form = new FormData();
        for (let key in formData) {
            if (formData[key] !== null) form.append(key, formData[key]);
        }

        try {
            const res = await fetch(`${url}/auth/update/${isLoggedIn.user_id}`, {
                method: "PUT",


                body: form,

            });
            const data = await res.json();
            console.log(data)
            // toast.success("Profile updated successfully");
            setEditMode(false);
            fetchSingleuser();
        } catch (err) {
            console.error("Update error:", err);
        }
    };











    if (!userData) {
        return (
            <div className="hbtecom-loading-wrapper">
                <div className="hbtecom-spinner"></div>
            </div>
        );
    }


    return (
        <>
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="hbtecom-container">
                    <h2 className="hbtecom-title">Account Settings</h2>
                    <div className="hbtecom-profile-box">
                        <div className="hbtecom-field">
                            <label className="hbtecom-label">Full Name:</label>
                            {editMode ? (
                                <input
                                    name="full_name"
                                    value={formData?.full_name || ""}
                                    onChange={handleChange}
                                    className="hbtecom-input"
                                />
                            ) : (
                                <span>{userData?.full_name}</span>
                            )}
                        </div>

                        <div className="hbtecom-field">
                            <label className="hbtecom-label">Email:</label>
                            <span>{userData?.email}</span>
                        </div>

                        <div className="hbtecom-field">
                            <label className="hbtecom-label"> ID:</label>
                            <span>{userData?.user_id}</span>
                        </div>


                        <div className="hbtecom-field">
                            <label className="hbtecom-label">Mobile:</label>

                            {editMode ? (
                                <input
                                    name="mobile"
                                    value={formData?.mobile || ""}
                                    onChange={handleChange}
                                    className="hbtecom-input"
                                />
                            ) : (
                                <span>{userData?.mobile || "N/A"}</span>
                            )}
                        </div>
                        <div className="hbtecom-field">
                            <label className="hbtecom-label">Invoice Address:</label>

                            {editMode ? (
                                <input
                                    // ref={autocompleteRef}
                                    name="office_address"
                                    defaultValue={formData?.office_address || ""}
                                    className="hbtecom-input"
                                    onChange={handleChange}
                                    placeholder="Enter your operational address"
                                />

                            ) : (
                                <span>{userData?.office_address || "N/A"}</span>
                            )}
                        </div>



                        <div className="hbtecom-field">
                            <label className="hbtecom-label">Customer Note:</label>

                            {editMode ? (
                                <ReactQuill
                                    theme="snow"
                                    name="customer_note"
                                    value={formData?.custom_note || ""}
                                    onChange={(value) =>
                                        setFormData((prev) => ({ ...prev, custom_note: value }))
                                    }
                                    className="hbtecom-input"
                                />
                            ) : (
                                <div
                                    className="hbtecom-note"
                                    dangerouslySetInnerHTML={{
                                        __html: DOMPurify.sanitize(userData?.custom_note || "N/A"),
                                    }}
                                />
                            )}
                        </div>

                           

                    {editMode && (
                        <div className="hbtecom-field">
                            <label className="hbtecom-label">Logo Type:</label>

                            <select
                                className="hbtecom-input"
                                value={useTextLogo ? "text" : "image"}
                                onChange={(e) => setUseTextLogo(e.target.value === "text")}
                            >
                                <option value="image">Upload Image</option>
                                <option value="text">Use Text Logo</option>
                            </select>

                        </div>
                    )}


                    {useTextLogo && (
                        <div className="hbtecom-field">
                            <label className="hbtecom-label">Text Logo Name:</label>
                            {
                                editMode ? (
                                    <input
                                        type="text"
                                        name="orignal_logoname"
                                        value={formData?.orignal_logoname || ""}
                                        onChange={(e) => {
                                            setFormData({ ...formData, orignal_logoname: e.target.value, profilePic: null });
                                        }}
                                        className="hbtecom-input"
                                    />
                                ) : (
                                    <span>{userData?.orignal_logoname || "N/A"}</span>
                                )}


                        </div>
                    )}


                    {editMode ? (
                        !useTextLogo && (
                            <div className="hbtecom-field">
                                <label className="hbtecom-label">Upload Logo:</label>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => {
                                        setFormData({ ...formData, profile: e.target.files[0], orignal_logoname: null });
                                    }}
                                    className="hbtecom-input"
                                />
                            </div>
                        )
                    ) : (
                        <div className="hbtecom-field">
                            <label className="hbtecom-label">Logo:</label>
                            {userData?.profile ? (
                                <img
                                    src={`${url}/${userData?.profile}`}
                                    alt="Profile"
                                    className="hbtecom-profile-pic"
                                />
                            ) : userData?.orignal_logoname ? (
                                <span className="hbtecom-text-logo">{userData?.orignal_logoname}</span>
                            ) : (
                                <span>No logo set</span>
                            )}
                        </div>
                    )}
                    <div className="hbtecom-buttons">
                        {editMode ? (
                            <>
                                <button className="hbtecom-btn hbtecom-save" onClick={handleSubmit}>Save</button>
                                <button className="hbtecom-btn hbtecom-cancel" onClick={() => setEditMode(false)}>Cancel</button>
                            </>
                        ) : (
                            <button className="hbtecom-btn hbtecom-edit" onClick={() => setEditMode(true)}>Edit</button>
                        )}
                    </div>


                </div>

            </div>
        </div >


        </>
    );
};

export default Setting;